import { Box, Card, CardContent, CardMedia, Grid, Typography, Paper } from "@mui/material";
import { styled } from '@mui/material/styles';
import { MakerData } from "../types/type";
import { useTranslation } from "react-i18next";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#4B4B4B',
    ...theme.typography.body2,
    textAlign: 'center',
    color: "white",
    width: "20vw",
    maxWidth: "100px",
    fontSize: "11px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "3px"
}));

function OverviewCard(props: {targetMarker:MakerData,handleCardClick:(targetMarker:MakerData) => void, myPlaces: number[]}): JSX.Element {
    const {
        targetMarker,
        handleCardClick,
        myPlaces
    } = props
    
    const { t } = useTranslation();

    return (
        <Card 
            sx={{ 
                display: 'flex',
                width:"90vw",
                maxWidth:"450px",
                marginTop:1, 
                borderColor: targetMarker.id !== null && myPlaces.includes(targetMarker.id) ? 'rgb(75, 239, 16)' : 'inherit',
                borderWidth: targetMarker.id !== null && myPlaces.includes(targetMarker.id) ? 3 : 0, 
                borderStyle: 'solid'
            }}
            onClick={() => {
                handleCardClick(targetMarker)
            }}
        >
            <CardMedia
                component="img"
                sx={{ width: 130 ,height: 130,padding: 1}}
                image={`${targetMarker.imageUrl}`}
            />
            <CardContent
                sx={{padding: 1,display: 'flex',flexDirection: 'column',justifyContent: 'center',alignItems: 'start'}}
            >
                <Box
                marginBottom={0.5}
                >
                    <Typography component="div" variant="caption">
                        {targetMarker.name}
                    </Typography>
                </Box>
                <Box>
                    <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                    {targetMarker.categoryNames.map((item, index) => (
                        (index<6)?<>
                            <Grid item xs={6} key={`grid${index}`}>
                            <Item key={`Item${index}`}>{item}</Item>
                            </Grid>    
                        </>
                        :(index==6)?
                            <Grid item xs={6} key={`grid${index}`}>
                            <Item key={`Item${index}`}>{t('component.overviewCard.others')}</Item>
                            </Grid>    
                        :<></>
                    ))}
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
};
export default OverviewCard;